import { Runtime } from "fp";

export type OptionalNonEmptyString = string | undefined;

export const fromUnknown = (unknown?: unknown | null): OptionalNonEmptyString =>
  unknown === ""
    ? undefined
    : unknown !== undefined && unknown !== null
    ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `${unknown}`
    : undefined;

export namespace Response {
  export const runtime = () =>
    Runtime.nullable(Runtime.union([Runtime.string(), Runtime.number()]));

  export const decode = (
    response?: Runtime.ToType<typeof runtime>
  ): OptionalNonEmptyString => fromUnknown(response);
}
